import { Navigate, RouteObject } from "react-router-dom";
import Home from "../pages/Home/Home";
import CallBack from "../pages/Auth/CallBack";
import Login from "../pages/Auth/Login";
import AccessDenied from "../pages/AccessDenied/AccessDenied";
import NotFound from "../pages/NotFound/NotFound";
import ErrorServer from "../pages/ErrorServer/ErrorServer";
import Logout from "../pages/Auth/Logout";
import ChangePassword from "src/pages/Auth/ChangePassword";
import BriefList from "../pages/Brief/List/BriefList";
import BriefView from "../pages/Brief/View/BriefView";
import BriefForm from "../pages/Brief/Form/BriefForm";
import MeList from "../pages/Brief/MeList/MeList";
import DownloadFile from "../pages/DownloadFile/DownloadFile";

const routers: RouteObject[] = [
  { path: "/", element: <Home /> },
  {
    path: "/login",
    children: [
      { path: "", element: <Login /> },
      { path: "oauth2/code/cognito", element: <CallBack /> },
    ],
  },
  {
    path: "logout",
    element: <Logout />,
  },
  {
    path: "change-password",
    element: <ChangePassword />,
  },
  {
    path: "/brief",
    children: [
      {
        path: "",
        element: <Navigate to="/brief/crear/campaign" replace />,
      },
      {
        path: "crear/:type",
        element: <BriefForm />,
      },
      {
        path: "editar/:type/:id",
        element: <BriefForm />,
      },
      {
        path: "list",
        element: <BriefList />,
      },
      {path: "me", element: <MeList />},
      { path: "ver/:id", element: <BriefView /> },
      { path: "descarga/:url", element: <DownloadFile /> },
    ],
  },
  {
    path: "acceso-restringido",
    element: <AccessDenied />,
  },
  {
    path: "error-server",
    element: <ErrorServer />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routers;
